export default "__VITE_ASSET__467a24a8__"